import {
  Badge,
  Box,
  Button,
  Menu,
  Switch,
  Text,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  getNoteTypes,
  noteTypeApproval,
  remoteNoteType,
} from "../../../services/note";
import { useDisclosure } from "@mantine/hooks";
import NoteTypeDrawer from "../../../components/NoteTypeModal/NoteTypeDrawer";
import { useSelector } from "react-redux";
import useStyles from "./style";
import deleteModalIcon from "../../../images/deleteModalIcon.png";
import CustomModal from "../../../components/CustomModal/CustomModal";
import ApprovalModal from "./ApprovalModal";


export const NoteCard = ({ note }) => {
  const { profile } = useSelector((state) => state?.profile);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [view, setView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [approvalRequired, setActive] = useState(
    note?.approvalRequired || false
  );
  const [successModalOpen, setSuccessModalOpen] = useState(false);

  useEffect(() => {
    if (note?.general === false) {
      // If type is not general
      if (note?.approvalRequired !== undefined) {
        setActive(note?.approvalRequired);
      }
    } else {
      // If type is general
      let adminIndex = note?.adminApprovals?.findIndex(
        (_v) => _v?.admin === profile?.user?.id
      );
      if (adminIndex !== -1) {
        setActive(note?.adminApprovals[adminIndex]?.status);
      } else {
        if (note?.approvalRequired !== undefined) {
          setActive(note?.approvalRequired);
        }
      }
    }

    // if (note?.approvalRequired !== undefined) {
    //   setActive(note?.approvalRequired);
    // }
  }, [note]);

  const getHeaderColor = (noteName) => {
    switch (noteName) {
      case "Progress Note":
        return "#F4F3FF";
      case "Incident Note":
        return "#E5E5E5";
      case "Medication Note":
        return "#E6F6F4";
      default:
        return "#F2F4F7";
    }
  };

  const { classes } = useStyles({ headerColor: getHeaderColor(note?.name) });
  const updateStatus = async (isChecked) => {
    // setActive(isChecked);
    try {
      // setLoading(true);
      const response = await noteTypeApproval({
        id: note?.id,
        approvalRequired: isChecked,
      });
      if (!successModalOpen && response.status === 200) {
        setSuccessModalOpen(true);
      } else {
        setLoading(false);
        setActive(!isChecked);
      }
    } catch (error) {
      // setLoading(false);
      console.error("Error updating note status:", error);
    }
  };

  const handleDelete = () => {
    remoteNoteType(note?.id);
    setDeleteModalOpen(false);
  };

  function handleRowClick() {
    setView(true);
    open();
  }
  return (
    <>
      <Box className={classes.noteCard}>
        <Box className={classes.header}>
          <Text ff={"Inter"} fw={600} fs={"16px"} c={"#000"}>
            {note?.name}
          </Text>
          <Menu shadow="md" width={100}>
            <Menu.Target>
              <Button variant="unstyled">
                <BsThreeDotsVertical
                  size={20}
                  color="#737373"
                  style={{ cursor: "pointer" }}
                />
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={handleRowClick}>View</Menu.Item>
              <Menu.Item onClick={open} disabled={note?.general}>
                Edit
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          <NoteTypeDrawer
            opened={opened}
            close={() => {
              close();
              setView(false);
            }}
            title={view ? "View Note Type" : "Edit Note Type"}
            data={note}
            view={view}
            setView={setView}
          />
        </Box>
        <Box className={classes.body}>
          <Box mt={10}>
            <Text ff={"Inter"} fw={600} fs={"16px"} c={"#A3A3A3"} ml={20}>
              Fields
            </Text>
            {note?.custom?.map((item, index) => (
              <Badge
                m={10}
                size="lg"
                key={index}
                radius="xl"
                color="gray"
                c={"#344054"}
              >
                {item?.field}
              </Badge>
            ))}
          </Box>
        </Box>
        <Box className={classes.footer}>
          <Button
            size="xs"
            color="red"
            radius="md"
            variant="light"
            disabled={note?.general}
            leftIcon={<IconTrash size={20} />}
            onClick={() => setDeleteModalOpen(true)}
          >
            Delete
          </Button>
          <Switch
            size="sm"
            color="green"
            defaultChecked
            disabled={loading}
            labelPosition="left"
            label="Approval Required"
            checked={approvalRequired}
            onChange={(event) => updateStatus(event.target.checked)}
          />
        </Box>
      </Box>
      {/* <Modal
        centered
        size="sm"
        zIndex={1000}
        radius={"md"}
        opened={deleteModalOpen}
        overlayProps={{ blur: 3 }}
        onClose={() => setDeleteModalOpen(false)}
        transitionProps={{ duration: 200 }}
        withCloseButton={false}
      >
        <Box className={classes.deleteModal}>
          <img
            src={deleteModalIcon}
            alt="Warning Icon"
            className={classes.deleteModalIcon}
          />
          <Text c={"#262626"} mb={0} ff={"Inter"} fw={600} fs={"20px"}>
            Delete Note
          </Text>
          <Text c={"#737373"} ff={"Inter"} fw={400} fs={"16px"} ta={"center"}>
            <small>
              Are you sure you want to delete this note? This action cannot be
              undone.
            </small>
          </Text>
          <Box className={classes.btnsFlex}>
            <Button
              size="sm"
              c={"#000"}
              radius="md"
              color="gray"
              variant="outline"
              onClick={() => setDeleteModalOpen(false)}
              className={classes.modalBtns}
            >
              Cancel
            </Button>
            <Button
              color="red"
              variant="filled"
              radius="md"
              size="sm"
              onClick={handleDelete}
              className={classes.modalBtns}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal> */}
      <ApprovalModal
        opened={successModalOpen}
        onClose={() => {
          return setSuccessModalOpen(false), getNoteTypes(1);
        }}
        approvalRequired={approvalRequired}
      />
      <CustomModal
        modalState={deleteModalOpen}
        modalTopImg={deleteModalIcon}
        modalTitle={"Delete Note"}
        modalText={
          "Are you sure you want to delete this note? This action cannot be undone."
        }
        closeModal={setDeleteModalOpen}
        buttonTwoFunc={handleDelete}
        colorOne={"gray"}
        colorTwo={"red"}
        btnTextOne="Cancel"
        btnTextTwo="Delete"
      />
    </>
  );
};
